
export const range = (size) => {
    return [...Array(size).keys()];
}